import type { FC } from 'react';
import { useState, useEffect } from 'react';
import { Modal, Button, Table, Form } from 'react-bootstrap';
import type { Task } from '@/types';

interface AddTaskModalProps {
  show: boolean;
  onHide: () => void;
  tasks: Task[];
  selectedTasks: Set<string>;
  onSave: (selectedTaskNames: string[]) => void;
}

const AddTaskModal: FC<AddTaskModalProps> = ({
  show,
  onHide,
  tasks,
  selectedTasks,
  onSave,
}) => {
  const [localSelectedTasks, setLocalSelectedTasks] = useState<Set<string>>(new Set());

  useEffect(() => {
    setLocalSelectedTasks(new Set(selectedTasks));
  }, [selectedTasks, show]);

  const handleToggleTask = (taskName: string) => {
    setLocalSelectedTasks((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(taskName)) {
        newSet.delete(taskName);
      } else {
        newSet.add(taskName);
      }
      return newSet;
    });
  };

  const handleSave = () => {
    onSave(Array.from(localSelectedTasks));
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Select Tasks</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table hover>
          <tbody>
            {tasks.map((task) => {
              const taskName = task.name.S;
              return (
                <tr key={taskName}>
                  <td>
                    <Form.Check
                      type="checkbox"
                      id={`task-${taskName}`}
                      label={taskName}
                      checked={localSelectedTasks.has(taskName)}
                      onChange={() => handleToggleTask(taskName)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {tasks.length === 0 && (
          <p className="text-muted text-center">No authorized tasks available for this week</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddTaskModal;
